export const ToolbarMenuItem = {
    ShowHideColumns: 'Show/Hide Columns',
    SaveColumns: 'Save Columns',
    SaveFilters: 'Save Filters',
    ResetColumns: 'Reset Columns',
    ResetFilters: 'Reset Filters',
    LoadFilters: 'Load Saved Filters',
    WfdSaveFilter: 'Save Filter'
} as const;

